import React from 'react';
import Modal from 'utils/packages/Modal';
import ToolTipContent from 'design-system/ToolTipContent';
export const InfoModal = {
    show: (title, description) => {
        Modal.show(<ToolTipContent subtitle={description} onPress={() => {
                Modal.hide();
            }} btnText="Okay"/>, {
            title,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
